import { Avatar, Box, Grid, Typography } from "@mui/material";
import { AppImages } from "app/appImages";
import { IconUserGear } from "components/icons";
import { UserPanelDtoPaginatedList } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { ListUsersMostPublicationDrawer } from "views/knowledge/feed/components/Panel/ListUsersMostPublicationDrawer";

interface IProps {
    title: string;
    channelId: string;
    viewData: UserPanelDtoPaginatedList;
}

/**
 * Painel lateral para usuários
 * @param props
 */
export const PanelChannelUsersMostPublication: React.FC<IProps> = (props) => {
    const { title, viewData } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const [dialog, setDialog] = useState<any>();

    const handleSeeAll = () => {
        setDialog(
            <ListUsersMostPublicationDrawer
                title={title}
                onClose={() => setDialog(null)}
                onGetData={({ searchText, pageNumber, pageSize }, signal) =>
                    new Promise<UserPanelDtoPaginatedList>((resolve, reject) => {
                        api.v1.knowledgeFeed.getFeedChannelPanelUsersMostPublication({ channelId: props.channelId, searchText, pageNumber, pageSize })
                            .then(result => resolve(result.data))
                            .catch(e => reject(e));
                    })
                }
            />
        );
    };

    return viewData.items.length > 0
        ? (
            <>
                {dialog}

                <Typography variant="h3">{title}</Typography>

                {viewData.items.map(item =>
                    <Box key={item.userId} marginTop={1}>
                        <Link to={RootPaths.BuildUserProfile(item.userId)}>
                            <Grid container alignItems="center" spacing={1} width="100%">
                                <Grid>
                                    <Avatar
                                        src={item.thumbnailUrl ?? AppImages.UserThumbnail}
                                        title={item.name}
                                        sx={(theme) => ({ width: 32, height: 32, backgroundColor: theme.palette.grey[200] })}
                                    />
                                </Grid>
                                <Grid size="grow" overflow="hidden">
                                    <Grid container alignItems="center" spacing={1} flexWrap="nowrap" width="100%">
                                        <Grid overflow="hidden">
                                            <Typography variant="h6" component="div" noWrap >
                                                {item.name}
                                            </Typography>
                                        </Grid>
                                        {
                                            item.isManager &&
                                            <Grid>
                                                <IconUserGear size="sm" color="muted" title={t("Feed.Panels.ChannelUsersMostPublication.ManagerTooltip")} />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Link>
                    </Box>
                )}
                {
                    viewData.totalRows > 5 &&
                    <Box marginTop={1}>
                        <Typography
                            variant="captionHeader"
                            component="a"
                            onClick={() => handleSeeAll()}
                        >
                            <b>{t("Feed.Panels.ChannelUsersMostPublication.SellAllText")}</b>
                        </Typography>
                    </Box>
                }
            </>
        )
        : null;
};
